$(".js-key-list").owlCarousel({
	center: false,
	items: 1,
	loop: true,
	lazyLoad: true,
	nav: false,
	dots: false,
	responsiveClass: true,
	responsiveRefreshRate: true,
	autoplay: true,
	responsive: {
		768: {
			items: 1,
			margin: 0,
		},
		960: {
			items: 1,
			margin: 0,
		},
		1200: {
			items: 1,
			margin: 0,
		},
		1920: {
			items: 1,
			margin: 0,
		},
	},
});

$(".js-stories-list").owlCarousel({
	items: 1,
	loop: true,
	nav: true,
	dots: false,
	autoplay: true,
	navText: [
		'<span class="custom-next">&#8592;</span>',
		'<span class="custom-prev">&#8594;</span>',
	],
	responsive: {
		600: {
			items: 1,
		},
	},
});
